module.exports = __webpack_public_path__ + "img/1F922.5821f5c6.svg";